import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useHistory } from "../../app-services/lib/router-compat";
import menuList from "../../components/Navbar/menu-list";

// Used as the `element` for every entry in the createBrowserRouter config
// (see AppLayout.js). Replaces v5's <Route render={props => ...}/> pattern:
// it injects the same {history, location, match} shape into the routed
// page component that withRouter/Route used to provide.
const GuardRoute = ({ path, component: Component }) => {
  // Select only what auth checks need — avoid returning the root state (react-redux v8 warning).
  const user = useSelector((state) => state.user);
  const history = useHistory();
  const params = useParams();
  window.reduxHistory = history;

  let o = menuList.find((o) => o.path == path);
  let middleware = () => {
    return true;
  };
  let check = () => (
    (o.needLogin==2&&user&&user.company.CompanyId)||
    (o.needLogin==1&&user)||
    (o.needLogin==3&&user && user.roles[0]=="Admin")||
    (o.needLogin==-1&&!user)||
    (o.needLogin==0)||
    (o.needLogin==-2)
  );

  return middleware() ? (
    <Component history={history} location={history.location} match={{ params, path }} />
  ) : (
    <Navigate to="/404" replace />
  );
};
export default GuardRoute;
